import { useState, useRef, useEffect } from 'react';
import { Col, Row } from 'antd';
import { useLightContext } from 'light-component';
import { Box } from '../../../box';
import { Image } from '../../../image';
import { Block } from '../../../block';
import { Upload, type UploadRef } from '../../../upload';
import { Button } from '../../../button';
import { useTranslation } from '../../../i18n';
import styles from '../style.module.less';
import { service } from '../service';
import { Highlighter } from '../../component';
import type { ImageItem } from '../../../image/types';
import type { ShotEyesImageProps } from './types';

export function ShotEyesImageInputMode(props: ShotEyesImageProps): React.ReactElement {
  const [t] = useTranslation();
  const { emitter, baseName } = useLightContext();
  const EMPTY_FILE = 'data:image/svg+xml;base64,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';
  const uploadRef = useRef<UploadRef>(null);
  const [images, setImages] = useState<ImageItem[]>([]);
  const [index, setIndex] = useState<number>(0);
  const multiple = props.fileMultiple ?? false;

  const onUploadImage = async (file: Blob | File | Blob[] | File[]): Promise<void> => {
    emitter.trigger('onImageUpload', {
      file,
      images,
      multiple,
      index,
      callback: (result: ImageItem[]) => {
        setImages(result);
        props.onPropsChange?.({
          value: result.map(item => ({
            path: item.src,
            type: 'image'
          }))
        });
      }
    });
  };

  const onEditImage = (idx: number): void => {
    setIndex(idx + 1);
    uploadRef.current?.open();
  };

  const onAdd = (): void => {
    setIndex(0);
    uploadRef.current?.open();
  };

  const onRemove = (idx: number): void => {
    if (images.length === 0) {
      return;
    }
    const result = [...images];
    result.splice(idx, 1);
    uploadRef.current?.delete?.(idx);

    setImages(result);
    props?.onPropsChange?.({ value: result.map(item => item.src) });
  };

  useEffect(() => {
    if (Array.isArray(props.value) && props?.value.length > 0) {
      const newImages = props.value.map(item => ({
        src: item.path,
        type: item.type as 'image' | 'video'
      }));
      setImages(newImages);
    }
  }, [props.value]);

  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          require={props.validator === 'required'}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>

      <Box className={styles.input}>
        <Block if={images.length === 0}>
          <Row>
            <Col span={12}>
              <img src={EMPTY_FILE} className={styles.checkImage} />
            </Col>
          </Row>
          <Row>
            <Col span={12} className={styles.defaultButton}>
              <Block if={images.length === 0}>
                <Button
                  size='small'
                  type='default'
                  label={t('上传')}
                  autoInsertSpace={false}
                  disabled={props.readonly === true}
                  onClick={() => onAdd()}
                />
              </Block>
            </Col>
          </Row>
        </Block>
        <Block if={images.length > 0}>
          <Row gutter={2}>
            <Image
              onEdit={idx => onEditImage(idx)}
              onRemove={idx => onRemove(idx)}
              className={styles.checkImage}
              src={images}
              preview={false}
              editName={t('上传')}
              removeName={t('删除')}
              mask={false}
              baseName={baseName}
            />
          </Row>
        </Block>
        <Upload
          accept={props.fileAccept}
          onUpload={async file => await onUploadImage(file)}
          ref={uploadRef}
          multiple={multiple}
        />
      </Box>
    </Box>
  );
}
